import React from 'react';
import Card from '../components/card';
import { InfoCopy, InfoLink } from '../components/info-link';
import RadioButtons from '../components/RadioButtons';
import { LoanCard } from './card-lenses';

const Info = (props) => (
  <InfoLink title="Refinancing Purposes" {...props}>
    <h6>Rate and Term Refinance (aka Limited Cash-Out Refinance)</h6>
    <InfoCopy>
      The refinancing of an existing mortgage for the purpose of changing the interest and/or term
      of a mortgage without advancing new money on the loan. This differs from a cash-out refinance,
      in which new money is advanced on the loan.
    </InfoCopy>
    <h6>Cash-Out Refinance</h6>
    <InfoCopy>
      A refinance transaction in which the amount of money received from the new loan exceeds the
      total of the money needed to repay the existing first mortgage, closing costs, points, and the
      amount required to satisfy any outstanding subordinate mortgage liens.
    </InfoCopy>
  </InfoLink>
);

const RefiPurpose = ({ model, onChange, ...cardProps }) => (
  <Card title="Why do you want to refinance your mortgage?" info={Info} {...cardProps}>
    <RadioButtons
      name="refiPurpose"
      value={model.get('refiPurpose')}
      onChange={onChange.bind(null, 'refiPurpose')}
      choices={[
        {
          value: 'RateAndTerm',
          label: 'Lower my interest rate or change the term'
        },
        {
          value: 'CashOut',
          label: 'Take cash out of my property'
        }
      ]}
    />
  </Card>
);

RefiPurpose.completed = ({ model }) =>
  ['RateAndTerm', 'CashOut'].includes(model.get('refiPurpose'));

RefiPurpose.id = 'RefiPurpose';

export default LoanCard(RefiPurpose);



// WEBPACK FOOTER //
// ./src/cards/refi-purpose.js